module.exports = __webpack_public_path__ + "static/progetto_martinetti12-f18216ea4de56e8da29d9c010dd5e1c1.jpg";